// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3fBNI","balanceDisclaimer":"posDashboard_balanceDisclaimer__101Kp"};